<template>
	<div class="mapContainer">
		<sky-charts
			ref="chart"
			:api-conf="apiConf"
			:config="chartConfig"
			:extend="extend"
			:showTitle="false"
			:showShadow="true"
		></sky-charts>
	</div>
</template>

<script>
import apiConf from '@/backend/apiConfig/apiConfig';

export default {
	name: 'mapContainer',
	props: ['siteId'],
	data() {
		return {
			apiConf: {},
			extend: {
				series: {
					barMaxWidth: 40,
				},
				tooltip: {
					trigger: 'axis',
					formatter(val) {
						return `${val[0].name} </br> 访问数: ${val[0].value}`;
					},
				},
			},
			chartConfig: {
				type: 'veHistogram',
				columns: ['continent', 'cumulativeCount'],
				chartSettings: {
					legendName: {
						cumulativeCount: '访问数',
					},
				},
			},
		};
	},
	watch: {
		siteId: {
			async handler(val) {
				this.init();
			},
			immediate: true,
			deep: true,
		},
	},
  mounted() {
    this.init()
  },
	methods: {
		init() {
			this.apiConf = {
				api: `${apiConf.websiteMonitor.siteTestToolCountry}?serviceSiteId=${this.siteId}`,
				type: 'get',
			};
			this.$refs.chart && this.$refs.chart.initCharts();
		},
	},
};
</script>

<style lang="scss" scoped>
.mapContainer {
	#container {
		padding: 0px;
		margin: 0px;
		width: 100%;
		height: 400px;
	}
}
</style>
